// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2neZK","rightAdornment":"Header_rightAdornment__WT3u6"};